import { Dispatch } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { callWhen } from '../utils/time';

import { VideoRoom } from '../api/videoroom';
import { AudioRoom } from '../api/audioroom';
import { ChatRoom } from '../api/chatroom';
import {
  statsStart,
  sendConferenceMetadata,
  sendUserMetadata,
  reportError
} from '../callstats';
import { newEvent, ERROR, INFO, WARNING } from '../notifications';
import { getLogger } from '../logger';

import {
  State,
  Stream,
  StreamType,
  Params,
  RoomError,
  RoomLayout,
  RoomLayoutStreamType,
  RoomLayoutConfig,
  ScreenSourceType,
  Publisher,
  UserStreamType,
  ScreenSharingOptions,
  StreamOptions,
  RosterUser,
  VideoQualityOptions,
  Error as VideoRoomError,
  ChatMessageClass,
  UserMessageSubClass,
  EventMessageSubClass,
  ChatMessageError,
  ChatMessageErrorType,
} from '../redux_types';


export const ROOM_CREATED = 'ROOM_CREATED';
export const LOCALSTREAM_VIDEO_ADD = 'LOCALSTREAM_VIDEO_ADD';
export const LOCALSTREAM_VIDEO_REMOVE = 'LOCALSTREAM_VIDEO_REMOVE';
export const LOCALSTREAM_AUDIO_ADD = 'LOCALSTREAM_AUDIO_ADD';
export const LOCALSTREAM_AUDIO_REMOVE = 'LOCALSTREAM_AUDIO_REMOVE';
export const LOCALSTREAM_ERROR = 'LOCALSTREAM_ERROR';
export const REMOTESTREAM_VIDEO_ADD = 'REMOTESTREAM_VIDEO_ADD';
export const REMOTESTREAM_VIDEO_REMOVE = 'REMOTESTREAM_VIDEO_REMOVE';
export const REMOTESTREAM_VIDEO_REMOVE_ALL = 'REMOTESTREAM_VIDEO_REMOVE_ALL';
export const SCREEN_REQUESTED = 'SCREEN_REQUESTED';
export const SCREEN_VIDEO_ADD = 'SCREEN_VIDEO_ADD';
export const SCREEN_VIDEO_REMOVE = 'SCREEN_VIDEO_REMOVE';
export const SCREEN_ERROR = 'SCREEN_ERROR';
export const TALKING_CHANGE = 'TALKING_CHANGE';
export const MUTEVIDEO = 'MUTEVIDEO';
export const MUTEVIDEO_REQUEST = 'MUTEVIDEO_REQUEST';
export const MUTEAUDIO_REQUEST = 'MUTEAUDIO_REQUEST';
export const MUTEVIDEO_REQUEST_ERROR = 'MUTEVIDEO_REQUEST_ERROR';
export const MUTEAUDIO_REQUEST_ERROR = 'MUTEAUDIO_REQUEST_ERROR';
export const MUTEAUDIO = 'MUTEAUDIO';
export const ENABLE_DESKTOP_CONTROL = 'ENABLE_DESKTOP_CONTROL';
export const DESKTOP_CONTROL_REQUESTED = 'DESKTOP_CONTROL_REQUESTED';
export const MUTEALLAUDIO_REQUEST = 'MUTEALLAUDIO_REQUEST';
export const MUTEALLAUDIO_DONE = 'MUTEALLAUDIO_DONE';
export const CHANGE_USER_ROLE_REQUEST = 'CHANGE_USER_ROLE_REQUEST';
export const CHANGE_USER_ROLE_SUCCESS = 'CHANGE_USER_ROLE_SUCCESS';
export const CHANGE_USER_ROLE_ERROR = 'CHANGE_USER_ROLE_ERROR';
export const APPLY_LAYOUT_REQUEST = 'APPLY_LAYOUT_REQUEST';
export const APPLY_LAYOUT_SUCCESS = 'APPLY_LAYOUT_SUCCESS';
export const APPLY_LAYOUT_ERROR = 'APPLY_LAYOUT_ERROR';
export const LOCK_ROOM_REQUEST = 'LOCK_ROOM_REQUEST';
export const LOCK_ROOM_SUCCESS = 'LOCK_ROOM_SUCCESS';
export const LOCK_ROOM_ERROR = 'LOCK_ROOM_ERROR';
export const FORCE_LAYOUT = 'FORCE_LAYOUT';
export const KICK_USER_REQUEST = 'KICK_USER_REQUEST';
export const KICK_USER_SUCCESS = 'KICK_USER_SUCCESS';
export const KICK_USER_ERROR = 'KICK_USER_ERROR';
export const EXPAND_STREAMVIDEO = 'EXPAND_STREAMVIDEO';
export const ENLARGE_STREAMVIDEO = 'ENLARGE_STREAMVIDEO';
export const PIP_USER = 'PIP_USER';
export const FULLSCREEN_USER = 'FULLSCREEN_USER';
export const INVITE_PARTICIPANTS_REQUEST = 'INVITE_PARTICIPANTS_REQUEST';
export const INVITE_PARTICIPANTS_SUCCESS = 'INVITE_PARTICIPANTS_SUCCESS';
export const INVITE_PARTICIPANTS_ERROR = 'INVITE_PARTICIPANTS_ERROR';
export const INVITE_PARTICIPANTS_TOGGLE_DIALOG = 'INVITE_PARTICIPANTS_TOGGLE_DIALOG';
export const SET_CHAT_OPEN = 'SET_CHAT_OPEN';
export const PUBLIC_USERMESSAGE = 'PUBLIC_USERMESSAGE';
export const PUBLIC_USERMESSAGE_RESET_UNREAD = 'PUBLIC_USERMESSAGE_RESET_UNREAD';
export const PRIVATE_USERMESSAGE = 'PRIVATE_USERMESSAGE';
export const PRIVATE_USERMESSAGE_RESET_UNREAD_THREAD = 'PRIVATE_USERMESSAGE_RESET_UNREAD_THREAD';
export const PRIVATE_USERMESSAGE_RESET_UNREAD = 'PRIVATE_USERMESSAGE_RESET_UNREAD';
export const EVENTMESSAGE = 'EVENTMESSAGE';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const ROOM_ERROR = 'ROOM_ERROR';
export const ROOM_ERROR_ACKED = 'ROOM_ERROR_ACKED';
export const START_RECORDING_REQUEST = 'START_RECORDING_REQUEST';
export const START_RECORDING_SUCCESS = 'START_RECORDING_SUCCESS';
export const START_RECORDING_ERROR = 'START_RECORDING_ERROR';
export const STOP_RECORDING_REQUEST = 'STOP_RECORDING_REQUEST';
export const STOP_RECORDING_SUCCESS = 'STOP_RECORDING_SUCCESS';
export const STOP_RECORDING_ERROR = 'STOP_RECORDING_ERROR';
export const START_LIVESTREAMING_REQUEST = 'START_LIVESTREAMING_REQUEST';
export const START_LIVESTREAMING_SUCCESS = 'START_LIVESTREAMING_SUCCESS';
export const START_LIVESTREAMING_ERROR = 'START_LIVESTREAMING_ERROR';
export const STOP_LIVESTREAMING_REQUEST = 'STOP_LIVESTREAMING_REQUEST';
export const STOP_LIVESTREAMING_SUCCESS = 'STOP_LIVESTREAMING_SUCCESS';
export const STOP_LIVESTREAMING_ERROR = 'STOP_LIVESTREAMING_ERROR';
export const SET_LIVESTREAMABLE = 'SET_LIVESTREAMABLE';
export const SET_RECORDABLE = 'SET_RECORDABLE';
export const SET_SHARE_SCREENS = 'SET_SHARE_SCREENS';
export const DURATION_UPDATE = 'DURATION_UPDATE';
export const TOGGLE_DESKSHARE = 'TOGGLE_DESKSHARE';
export const SET_MOUSE_POINTER = 'SET_MOUSE_POINTER';
export const CLEAR_MOUSE_POINTERS = 'CLEAR_MOUSE_POINTERS';
export const DIAL_PARTICIPANT_REQUEST = "DIAL_PARTICIPANT_REQUEST";
export const DIAL_PARTICIPANT_SUCCESS = "DIAL_PARTICIPANT_SUCCESS";
export const DIAL_PARTICIPANT_ERROR = "DIAL_PARTICIPANT_ERROR";
export const TOGGLE_DIALOUT = "TOGGLE_DIALOUT";
export const PUBLISHER_ADD = "PUBLISHER_ADD";
export const PUBLISHER_REMOVE = "PUBLISHER_REMOVE";
export const SUBSCRIBE_VIDEO_REQUEST = "SUBSCRIBE_VIDEO_REQUEST";
export const SUBSCRIBE_VIDEO_REQUEST_ERROR = "SUBSCRIBE_VIDEO_REQUEST_ERROR";
export const SUBSCRIBE_VIDEO_SUCCESS = "SUBSCRIBE_VIDEO_REQUEST_ERROR";
export const ADD_OBSERVED_SCREEN = "ADD_OBSERVED_SCREEN";
export const REMOVE_OBSERVED_SCREEN = "REMOVE_OBSERVED_SCREEN";


interface RoomCreatedAction {
  type: typeof ROOM_CREATED;
  payload: {
    roomObject: VideoRoom;
    roomAudio: AudioRoom;
    chatRoom: ChatRoom;
  };
}


interface SetChatOpenAction {
  type: typeof SET_CHAT_OPEN;
  payload: {
    isOpen: boolean;
  };
}


interface PublicUserMessageReceivedAction {
  type: typeof PUBLIC_USERMESSAGE;
  payload: {
    class: ChatMessageClass;
    subClass: UserMessageSubClass;
    from: string;
    fromDisplayName: string;
    message: string;
    timestamp: number;
    msgId: string;
  };
}


interface PublicUserMessagesResetAction {
  type: typeof PUBLIC_USERMESSAGE_RESET_UNREAD;
  payload: {
  };
}


interface PrivateUserMessageReceivedAction {
  type: typeof PRIVATE_USERMESSAGE;
  payload: {
    myUsername: string;
    class: ChatMessageClass;
    subClass: UserMessageSubClass;
    to: string;
    toDisplayName: string;
    from: string;
    fromDisplayName: string;
    message: string;
    timestamp: number;
    msgId: string;
  };
}


interface PrivateUserMessagesResetAction {
  type: typeof PRIVATE_USERMESSAGE_RESET_UNREAD;
  payload: {
  };
}


interface PrivateUserMessagesResetThreadAction {
  type: typeof PRIVATE_USERMESSAGE_RESET_UNREAD_THREAD;
  payload: {
    thread: string;
  };
}


interface EventMessageReceivedAction {
  type: typeof EVENTMESSAGE;
  payload: {
    class: ChatMessageClass;
    subClass: EventMessageSubClass;
    username: string;
    fromDisplayName: string;
    timestamp: number;
  };
}


interface StreamLocalVideoAddedAction {
  type: typeof LOCALSTREAM_VIDEO_ADD;
  payload: {
    stream: Stream;
  };
}


interface StreamLocalVideoRemovedAction {
  type: typeof LOCALSTREAM_VIDEO_REMOVE;
  payload: {
  };
}


interface LocalStreamErrorAction {
  type: typeof LOCALSTREAM_ERROR;
  payload: {
    errorMessage: string;
  };
  error: boolean;
}


interface StreamAudioAddedAction {
  type: typeof LOCALSTREAM_AUDIO_ADD;
  payload: {
    audio_stream: Stream;
  };
}


interface StreamAudioRemovedAction {
  type: typeof LOCALSTREAM_AUDIO_REMOVE;
  payload: {
  };
}


interface StreamRemoteVideoAdded {
  type: typeof REMOTESTREAM_VIDEO_ADD;
  payload: {
    user_id: string;
    stream: Stream;
    type: StreamType;
  };
}


interface StreamRemoteVideoRemoved {
  type: typeof REMOTESTREAM_VIDEO_REMOVE;
  payload: {
    user_id: string;
    type: StreamType;
  };
}


interface VideoMuteToggledAction {
  type: typeof MUTEVIDEO;
  payload: {
    user_id: string;
    type: StreamType;
    muted: boolean;
  };
}


interface VideoMuteToggleRequestedAction {
  type: typeof MUTEVIDEO_REQUEST;
  payload: {
    user_id: string;
  };
}


interface VideoMuteToggleErrorAction {
  type: typeof MUTEVIDEO_REQUEST_ERROR;
  payload: {
    user_id: string;
  };
}


interface AudioMuteToggledAction {
  type: typeof MUTEAUDIO;
  payload: {
    user_id: string;
    muted: boolean;
  };
}


interface AudioMuteToggleRequestedAction {
  type: typeof MUTEAUDIO_REQUEST;
  payload: {
    user_id: string;
  };
}


interface AudioMuteToggleErrorAction {
  type: typeof MUTEAUDIO_REQUEST_ERROR;
  payload: {
    user_id: string;
  };
}


interface EnableDesktopControlAction {
  type: typeof ENABLE_DESKTOP_CONTROL;
  payload: {
    userId: string;
    desktopControlEnabled: boolean;
    desktopControlType: string;
  };
}


interface RequestedDesktopControlAction {
  type: typeof DESKTOP_CONTROL_REQUESTED;
  payload: {
    userId: string;
  };
}


interface AudioMuteAllRequestedAction {
  type: typeof MUTEALLAUDIO_REQUEST;
  payload: {
    user_id: string;
  };
}


interface AudioMuteAllDoneAction {
  type: typeof MUTEALLAUDIO_DONE;
  payload: {
    user_id: string;
  };
}


interface StreamAllRemoteVideoRemovedAction {
  type: typeof REMOTESTREAM_VIDEO_REMOVE_ALL;
  payload: {
  };
}


interface RequestedScreenAction {
  type: typeof SCREEN_REQUESTED;
  payload: {
  };
}


interface LocalScreenAddedAction {
  type: typeof SCREEN_VIDEO_ADD;
  payload: {
    stream: Stream;
    screenSourceType: ScreenSourceType;
  };
}


interface LocalScreenErrorAction {
  type: typeof SCREEN_ERROR;
  payload: {
    errorMessage: string;
  };
  error: boolean;
}


interface LocalScreenRemovedAction {
  type: typeof SCREEN_VIDEO_REMOVE;
  payload: {
  };
}


interface StreamAllRemoteVideRemovedAction {
  type: typeof REMOTESTREAM_VIDEO_REMOVE_ALL;
  payload: {
  };
}


interface TalkingChangeAction {
  type: typeof TALKING_CHANGE;
  payload: {
    is_talking: boolean;
    username: string;
  };
}


interface ChangeUserRoleRequestedAction {
  type: typeof CHANGE_USER_ROLE_REQUEST;
  payload: {
    user_id: string;
  };
}


interface ChangeUserRoleSuccessAction {
  type: typeof CHANGE_USER_ROLE_SUCCESS;
  payload: {
    user_id: string;
  };
}


interface ChangeUserRoleErrorAction {
  type: typeof CHANGE_USER_ROLE_ERROR;
  payload: {
    user_id: string;
  };
}


interface ApplyLayoutRequestedAction {
  type: typeof APPLY_LAYOUT_REQUEST;
  payload: {
  };
}


interface ApplyLayoutSuccessAction {
  type: typeof APPLY_LAYOUT_SUCCESS;
  payload: {
  };
}


interface ApplyLayoutErrorAction {
  type: typeof APPLY_LAYOUT_ERROR;
  payload: {
  };
}


interface ForceLayoutAction {
  type: typeof FORCE_LAYOUT;
  payload: {
    layout_type: RoomLayout;
    layout_config: RoomLayoutConfig;
  };
}


interface ChangeLayoutAction {
  type: typeof CHANGE_LAYOUT;
  payload: {
    layout_type: RoomLayout;
    layout_config: RoomLayoutConfig;
  };
}


interface LockRoomRequestedAction {
  type: typeof LOCK_ROOM_REQUEST;
  payload: {
  };
}


interface LockRoomStatusAction {
  type: typeof LOCK_ROOM_SUCCESS;
  payload: {
    is_locked: boolean;
  };
}


interface LockRoomErrorAction {
  type: typeof LOCK_ROOM_ERROR;
  payload: {
  };
}


interface ToggleDeskshareAction {
  type: typeof TOGGLE_DESKSHARE;
  payload: {
    is_enabled: boolean;
  };
}


interface ToggleDialoutAction {
  type: typeof TOGGLE_DIALOUT;
  payload: {
    is_enabled: boolean;
  };
}


interface SetRecordableAction {
  type: typeof SET_RECORDABLE;
  payload: {
    recordable: boolean;
  };
}


interface StartRecordingRequestedAction {
  type: typeof START_RECORDING_REQUEST;
  payload: {
  };
}


interface StartRecordingSuccessAction {
  type: typeof START_RECORDING_SUCCESS;
  payload: {
  };
}


interface StartRecordingErrorAction {
  type: typeof START_RECORDING_ERROR;
  payload: {
  };
}


interface StopRecordingRequestedAction {
  type: typeof STOP_RECORDING_REQUEST;
  payload: {
  };
}


interface StopRecordingSuccessAction {
  type: typeof STOP_RECORDING_SUCCESS;
  payload: {
  };
}


interface StopRecordingErrorAction {
  type: typeof STOP_RECORDING_ERROR;
  payload: {
  };
}


interface SetLivestreamableAction {
  type: typeof SET_LIVESTREAMABLE;
  payload: {
    streamable: boolean;
  };
}


interface StartLivestreamingRequestedAction {
  type: typeof START_LIVESTREAMING_REQUEST;
  payload: {
  };
}


interface StartLivestreamingSuccessAction {
  type: typeof START_LIVESTREAMING_SUCCESS;
  payload: {
  };
}


interface StartLivestreamingErrorAction {
  type: typeof START_LIVESTREAMING_ERROR;
  payload: {
  };
}


interface StopLivestreamingRequestedAction {
  type: typeof STOP_LIVESTREAMING_REQUEST;
  payload: {
  };
}


interface StopLivestreamingSuccessAction {
  type: typeof STOP_LIVESTREAMING_SUCCESS;
  payload: {
  };
}


interface StopLivestreamingErrorAction {
  type: typeof STOP_LIVESTREAMING_ERROR;
  payload: {
  };
}


interface KickUserRequestedAction {
  type: typeof KICK_USER_REQUEST;
  payload: {
    user_id: string;
  };
}


interface KickUserSuccessAction {
  type: typeof KICK_USER_SUCCESS;
  payload: {
    user_id: string;
  };
}


interface KickUserErrorAction {
  type: typeof KICK_USER_ERROR;
  payload: {
    user_id: string;
  };
}


interface ExpandStreamVideoRequestedAction {
  type: typeof EXPAND_STREAMVIDEO;
  payload: {
    featured_id: string;
    stream_type: RoomLayoutStreamType;
  };
}


interface EnlargeStreamVideoRequestedAction {
  type: typeof ENLARGE_STREAMVIDEO;
  payload: {
    enlarge: boolean;
  };
}


interface TogglePipUserAction {
  type: typeof PIP_USER;
  payload: {
    pipUser: string | null;
  };
}


interface ToggleFullscreenUserAction {
  type: typeof FULLSCREEN_USER;
  payload: {
    fullscreenUser: string | null;
  };
}


interface InviteParticipantsRequestedAction {
  type: typeof INVITE_PARTICIPANTS_REQUEST;
}


interface InviteParticipantsSuccessAction {
  type: typeof INVITE_PARTICIPANTS_SUCCESS;
}


interface InviteParticipantsErrorAction {
  type: typeof INVITE_PARTICIPANTS_ERROR;
  payload: {
    errCode: number;
  };
}


interface InviteParticipantsToggleDialogAction {
  type: typeof INVITE_PARTICIPANTS_TOGGLE_DIALOG;
}

interface DialParticipantRequestedAction {
  type: typeof DIAL_PARTICIPANT_REQUEST;
}


interface DialParticipantSuccessAction {
  type: typeof DIAL_PARTICIPANT_SUCCESS;
}


interface DialParticipantErrorAction {
  type: typeof DIAL_PARTICIPANT_ERROR;
  payload: {
    errCode: number;
  };
}


interface RoomErrorReceivedAction {
  type: typeof ROOM_ERROR;
  payload: {
    error: VideoRoomError;
    recoverable: boolean;
  };
}


interface RoomErrorAckedAction {
  type: typeof ROOM_ERROR_ACKED;
  payload: {
  };
}


interface MeetingDurationUpdateAction {
  type: typeof DURATION_UPDATE;
  payload: {
    elapsed: number;
  };
}


interface AddPublisherAction {
  type: typeof PUBLISHER_ADD;
  payload: {
    publisher: Publisher;
  };
}


interface RemovePublisherAction {
  type: typeof PUBLISHER_REMOVE;
  payload: {
    publisherId: number;
  };
}


interface SubscribeToVideoRequestedAction {
  type: typeof SUBSCRIBE_VIDEO_REQUEST;
  payload: {
    userId: string;
    type: UserStreamType;
  };
}


interface SubscribeToVideoErrorAction {
  type: typeof SUBSCRIBE_VIDEO_REQUEST_ERROR;
  payload: {
    userId: string;
    type: UserStreamType;
  };
}


interface SubscribeToVideoSuccessAction {
  type: typeof SUBSCRIBE_VIDEO_SUCCESS;
  payload: {
    userId: string;
    type: UserStreamType;
  };
}


interface AddObservedScreenAction {
  type: typeof ADD_OBSERVED_SCREEN;
  payload: {
    userId: string;
  };
}


interface RemoveObservedScreenAction {
  type: typeof REMOVE_OBSERVED_SCREEN;
  payload: {
    userId: string;
  };
}


export type Action =
  RoomCreatedAction
  | SetChatOpenAction
  | PublicUserMessageReceivedAction
  | PublicUserMessagesResetAction
  | PrivateUserMessageReceivedAction
  | PrivateUserMessagesResetAction
  | PrivateUserMessagesResetThreadAction
  | EventMessageReceivedAction
  | StreamLocalVideoAddedAction
  | LocalStreamErrorAction
  | StreamLocalVideoRemovedAction
  | StreamAudioAddedAction
  | StreamAudioRemovedAction
  | StreamRemoteVideoAdded
  | StreamRemoteVideoRemoved
  | VideoMuteToggledAction
  | VideoMuteToggleRequestedAction
  | VideoMuteToggleErrorAction
  | AudioMuteToggledAction
  | AudioMuteToggleRequestedAction
  | AudioMuteToggleErrorAction
  | EnableDesktopControlAction
  | RequestedDesktopControlAction
  | AudioMuteAllRequestedAction
  | AudioMuteAllDoneAction
  | StreamAllRemoteVideoRemovedAction
  | RequestedScreenAction
  | LocalScreenAddedAction
  | LocalScreenErrorAction
  | LocalScreenRemovedAction
  | TalkingChangeAction
  | ChangeUserRoleRequestedAction
  | ChangeUserRoleSuccessAction
  | ChangeUserRoleErrorAction
  | ApplyLayoutRequestedAction
  | ApplyLayoutSuccessAction
  | ApplyLayoutErrorAction
  | ChangeLayoutAction
  | ForceLayoutAction
  | LockRoomRequestedAction
  | LockRoomStatusAction
  | LockRoomErrorAction
  | ToggleDeskshareAction
  | ToggleDialoutAction
  | SetRecordableAction
  | StartRecordingRequestedAction
  | StartRecordingSuccessAction
  | StartRecordingErrorAction
  | StopRecordingRequestedAction
  | StopRecordingSuccessAction
  | StopRecordingErrorAction
  | SetLivestreamableAction
  | StartLivestreamingRequestedAction
  | StartLivestreamingSuccessAction
  | StartLivestreamingErrorAction
  | StopLivestreamingRequestedAction
  | StopLivestreamingSuccessAction
  | StopLivestreamingErrorAction
  | KickUserRequestedAction
  | KickUserSuccessAction
  | KickUserErrorAction
  | ExpandStreamVideoRequestedAction
  | EnlargeStreamVideoRequestedAction
  | TogglePipUserAction
  | ToggleFullscreenUserAction
  | InviteParticipantsRequestedAction
  | InviteParticipantsSuccessAction
  | InviteParticipantsErrorAction
  | InviteParticipantsToggleDialogAction
  | DialParticipantRequestedAction
  | DialParticipantSuccessAction
  | DialParticipantErrorAction
  | RoomErrorReceivedAction
  | RoomErrorAckedAction
  | MeetingDurationUpdateAction
  | AddPublisherAction
  | RemovePublisherAction
  | SubscribeToVideoRequestedAction
  | SubscribeToVideoErrorAction
  | SubscribeToVideoSuccessAction
  | AddObservedScreenAction
  | RemoveObservedScreenAction


type ScreenStream = {
  stream: Stream;
  type: null | ScreenSourceType;
}
type RoomThunkAction = ThunkAction<void, State, null, Action>


function roomCreated(videoRoom: VideoRoom, audioRoom: AudioRoom, chatRoom: ChatRoom): RoomCreatedAction {
  return {
    type: ROOM_CREATED,
    payload: {
      roomObject: videoRoom,
      roomAudio: audioRoom,
      chatRoom: chatRoom,
    }
  };
}


function streamLocalVideoAdded(stream: Stream): StreamLocalVideoAddedAction {
  return {
    type: LOCALSTREAM_VIDEO_ADD,
    payload: {
      stream: stream,
    }
  };
}


function streamLocalVideoRemoved(): StreamLocalVideoRemovedAction {
  return {
    type: LOCALSTREAM_VIDEO_REMOVE,
    payload: {
    }
  };
}


function streamAudioAdded(stream: Stream): StreamAudioAddedAction {
  return {
    type: LOCALSTREAM_AUDIO_ADD,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      audio_stream: stream,
    }
  };
}


function streamAudioRemoved(): StreamAudioRemovedAction {
  return {
    type: LOCALSTREAM_AUDIO_REMOVE,
    payload: {
    }
  };
}


function addPublisher(p: Publisher): AddPublisherAction {
  return {
    type: PUBLISHER_ADD,
    payload: {
      publisher: p
    }
  };
}

function removePublisher(id: number): RemovePublisherAction {
  return {
    type: PUBLISHER_REMOVE,
    payload: {
      publisherId: id
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function streamRemoteVideoAdded(stream: Stream, user_id: string, type: StreamType): StreamRemoteVideoAdded {
  return {
    type: REMOTESTREAM_VIDEO_ADD,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
      stream: stream,
      type: type,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function streamRemoteVideoRemoved(user_id: string, type: StreamType): StreamRemoteVideoRemoved {
  return {
    type: REMOTESTREAM_VIDEO_REMOVE,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
      type: type,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function videoMuteToggled(user_id: string, type: StreamType, muted: boolean): VideoMuteToggledAction {
  return {
    type: MUTEVIDEO,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
      type: type,
      muted: muted,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function videoMuteToggleRequested(user_id: string): VideoMuteToggleRequestedAction {
  return {
    type: MUTEVIDEO_REQUEST,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function videoMuteToggleError(user_id: string): VideoMuteToggleErrorAction {
  return {
    type: MUTEVIDEO_REQUEST_ERROR,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


function subscribeToVideoRequested(uid: string, type: UserStreamType): SubscribeToVideoRequestedAction {
  return {
    type: SUBSCRIBE_VIDEO_REQUEST,
    payload: {
      userId: uid,
      type: type,
    }
  };
}


function subscribeToVideoError(uid: string, type: UserStreamType): SubscribeToVideoErrorAction {
  return {
    type: SUBSCRIBE_VIDEO_REQUEST_ERROR,
    payload: {
      userId: uid,
      type: type,
    }
  };
}


function subscribeToVideoSuccess(userId: string, type: UserStreamType): SubscribeToVideoSuccessAction {
  return {
    type: SUBSCRIBE_VIDEO_SUCCESS,
    payload: {
      userId: userId,
      type: type,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function audioMuteToggleRequested(user_id: string): AudioMuteToggleRequestedAction {
  return {
    type: MUTEAUDIO_REQUEST,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function audioMuteToggled(user_id: string, muted: boolean): AudioMuteToggledAction {
  return {
    type: MUTEAUDIO,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
      muted: muted,
    }
  };
}


export function onEnableDesktopControl(
  userId: string,
  desktopControlEnabled: boolean,
  desktopControlType: string
): EnableDesktopControlAction {
  return {
    type: ENABLE_DESKTOP_CONTROL,
    payload: {
      userId,
      desktopControlEnabled,
      desktopControlType,
    }
  };
}

function requestDesktopControl(userId: string): RequestedDesktopControlAction {
  return {
    type: DESKTOP_CONTROL_REQUESTED,
    payload: {
      userId: userId,
    }
  };
}

// eslint-disable-next-line @typescript-eslint/camelcase
function audioMuteToggleError(user_id: string): AudioMuteToggleErrorAction {
  return {
    type: MUTEAUDIO_REQUEST_ERROR,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function audioMuteAllRequested(user_id: string): AudioMuteAllRequestedAction {
  return {
    type: MUTEALLAUDIO_REQUEST,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function audioMuteAllDone(user_id: string): AudioMuteAllDoneAction {
  return {
    type: MUTEALLAUDIO_DONE,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


function streamAllRemoteVideoRemoved(): StreamAllRemoteVideoRemovedAction {
  return {
    type: REMOTESTREAM_VIDEO_REMOVE_ALL,
    payload: {
    }
  };
}


function requestScreen(): RequestedScreenAction {
  return {
    type: SCREEN_REQUESTED,
    payload: {
    }
  };
}


function localScreenAdded(screenStream: ScreenStream): LocalScreenAddedAction {
  return {
    type: SCREEN_VIDEO_ADD,
    payload: {
      stream: screenStream.stream,
      screenSourceType: screenStream.type,
    }
  };
}


function localScreenError(err: string): LocalScreenErrorAction {
  return {
    type: SCREEN_ERROR,
    payload: {
      errorMessage: err,
    },
    error: true,
  };
}


function localScreenRemoved(): LocalScreenRemovedAction {
  return {
    type: SCREEN_VIDEO_REMOVE,
    payload: {
    }
  };
}


function localStreamError(errMessage: string): LocalStreamErrorAction {
  return {
    type: LOCALSTREAM_ERROR,
    payload: {
      errorMessage: errMessage,
    },
    error: true,
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function onTalkingEvent(username: string, is_talking: boolean): TalkingChangeAction {
  return {
    type: TALKING_CHANGE,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_talking: is_talking,
      username: username,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function changeUserRoleRequested(user_id: string): ChangeUserRoleRequestedAction {
  return {
    type: CHANGE_USER_ROLE_REQUEST,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function changeUserRoleSuccess(user_id: string): ChangeUserRoleSuccessAction {
  return {
    type: CHANGE_USER_ROLE_SUCCESS,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function changeUserRoleError(user_id: string): ChangeUserRoleErrorAction {
  return {
    type: CHANGE_USER_ROLE_ERROR,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


function applyLayoutRequested(): ApplyLayoutRequestedAction {
  return {
    type: APPLY_LAYOUT_REQUEST,
    payload: {
    }
  };
}


function applyLayoutSuccess(): ApplyLayoutSuccessAction {
  return {
    type: APPLY_LAYOUT_SUCCESS,
    payload: {
    }
  };
}


function applyLayoutError(): ApplyLayoutErrorAction {
  return {
    type: APPLY_LAYOUT_ERROR,
    payload: {
    }
  };
}


function lockRoomRequested(): LockRoomRequestedAction {
  return {
    type: LOCK_ROOM_REQUEST,
    payload: {
    }
  };
}


export function lockRoomStatus(value: boolean): LockRoomStatusAction {
  return {
    type: LOCK_ROOM_SUCCESS,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_locked: value
    }
  };
}


function lockRoomError(): LockRoomErrorAction {
  return {
    type: LOCK_ROOM_ERROR,
    payload: {
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
export function toggleDeskshare(is_enabled: boolean): ToggleDeskshareAction {
  return {
    type: TOGGLE_DESKSHARE,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_enabled: is_enabled
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
export function toggleDialout(is_enabled: boolean): ToggleDialoutAction {
  return {
    type: TOGGLE_DIALOUT,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_enabled: is_enabled
    }
  };
}


export function setRecordable(value: boolean): SetRecordableAction {
  return {
    type: SET_RECORDABLE,
    payload: {
      recordable: value
    }
  };
}

function startRecordingRequested(): StartRecordingRequestedAction {
  return {
    type: START_RECORDING_REQUEST,
    payload: {
    }
  };
}


export function startRecordingSuccess(): StartRecordingSuccessAction {
  return {
    type: START_RECORDING_SUCCESS,
    payload: {
    }
  };
}


function startRecordingError(): StartRecordingErrorAction {
  return {
    type: START_RECORDING_ERROR,
    payload: {
    }
  };
}


function stopRecordingRequested(): StopRecordingRequestedAction {
  return {
    type: STOP_RECORDING_REQUEST,
    payload: {
    }
  };
}


export function stopRecordingSuccess(): StopRecordingSuccessAction {
  return {
    type: STOP_RECORDING_SUCCESS,
    payload: {
    }
  };
}


function stopRecordingError(): StopRecordingErrorAction {
  return {
    type: STOP_RECORDING_ERROR,
    payload: {
    }
  };
}


export function setLivestreamable(value: boolean): SetLivestreamableAction {
  return {
    type: SET_LIVESTREAMABLE,
    payload: {
      streamable: value
    }
  };
}


function startLivestreamingRequested(): StartLivestreamingRequestedAction {
  return {
    type: START_LIVESTREAMING_REQUEST,
    payload: {
    }
  };
}


export function startLivestreamingSuccess(): StartLivestreamingSuccessAction {
  return {
    type: START_LIVESTREAMING_SUCCESS,
    payload: {
    }
  };
}


function startLivestreamingError(): StartLivestreamingErrorAction {
  return {
    type: START_LIVESTREAMING_ERROR,
    payload: {
    }
  };
}


function stopLivestreamingRequested(): StopLivestreamingRequestedAction {
  return {
    type: STOP_LIVESTREAMING_REQUEST,
    payload: {
    }
  };
}


export function stopLivestreamingSuccess(): StopLivestreamingSuccessAction {
  return {
    type: STOP_LIVESTREAMING_SUCCESS,
    payload: {
    }
  };
}


function stopLivestreamingError(): StopLivestreamingErrorAction {
  return {
    type: STOP_LIVESTREAMING_ERROR,
    payload: {
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function kickUserRequested(user_id: string): KickUserRequestedAction {
  return {
    type: KICK_USER_REQUEST,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function kickUserSuccess(user_id: string): KickUserSuccessAction {
  return {
    type: KICK_USER_SUCCESS,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function kickUserError(user_id: string): KickUserErrorAction {
  return {
    type: KICK_USER_ERROR,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: user_id,
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
function expandStreamVideoRequested(user_id: string,
  streamType: RoomLayoutStreamType
): ExpandStreamVideoRequestedAction {
  return {
    type: EXPAND_STREAMVIDEO,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      featured_id: user_id,
      // eslint-disable-next-line @typescript-eslint/camelcase
      stream_type: streamType,
    }
  };
}


function enlargeStreamVideoRequested(enlarge: boolean): EnlargeStreamVideoRequestedAction {
  return {
    type: ENLARGE_STREAMVIDEO,
    payload: {
      enlarge: enlarge,
    }
  };
}


function inviteParticipantsRequested(): InviteParticipantsRequestedAction {
  return {
    type: INVITE_PARTICIPANTS_REQUEST,
  };
}


function inviteParticipantsSuccess(): InviteParticipantsSuccessAction {
  return {
    type: INVITE_PARTICIPANTS_SUCCESS
  };
}


function inviteParticipantsToggleDialog(): InviteParticipantsToggleDialogAction {
  return {
    type: INVITE_PARTICIPANTS_TOGGLE_DIALOG
  };
}


function inviteParticipantsError(errCode: number): InviteParticipantsErrorAction {
  return {
    type: INVITE_PARTICIPANTS_ERROR,
    payload: {
      errCode: errCode
    }
  };
}


function dialParticipantRequested(): DialParticipantRequestedAction {
  return {
    type: DIAL_PARTICIPANT_REQUEST,
  };
}


function dialParticipantSuccess(): DialParticipantSuccessAction {
  return {
    type: DIAL_PARTICIPANT_SUCCESS
  };
}


function dialParticipantError(errCode: number): DialParticipantErrorAction {
  return {
    type: DIAL_PARTICIPANT_ERROR,
    payload: {
      errCode: errCode
    }
  };
}


function publicUserMessageReceived(
  cls: ChatMessageClass,
  subClass: UserMessageSubClass,
  from: string,
  fromDisplayName: string,
  message: string,
  timestamp: number,
  msgId: string,
): PublicUserMessageReceivedAction {
  return {
    type: PUBLIC_USERMESSAGE,
    payload: {
      class: cls,
      subClass: subClass,
      from: from,
      fromDisplayName: fromDisplayName,
      message: message,
      timestamp: timestamp,
      msgId: msgId,
    }
  };
}


function privateUserMessageReceived(
  cls: ChatMessageClass,
  subClass: UserMessageSubClass,
  to: string,
  toDisplayName: string,
  from: string,
  fromDisplayName: string,
  message: string,
  timestamp: number,
  state: State,
  msgId: string,
): PrivateUserMessageReceivedAction {
  const myUsername = state.session.username;
  return {
    type: PRIVATE_USERMESSAGE,
    payload: {
      class: cls,
      subClass: subClass,
      to: to,
      toDisplayName: toDisplayName,
      from: from,
      fromDisplayName: fromDisplayName,
      message: message,
      timestamp: timestamp,
      myUsername: myUsername,
      msgId: msgId,
    }
  };
}


function eventMessageReceived(
  cls: ChatMessageClass,
  subClass: EventMessageSubClass,
  username: string,
  fromDisplayName: string,
  timestamp: number,
): EventMessageReceivedAction {
  return {
    type: EVENTMESSAGE,
    payload: {
      class: cls,
      subClass: subClass,
      username: username,
      fromDisplayName: fromDisplayName,
      timestamp: timestamp,
    }
  };
}


function roomErrorReceived(err: VideoRoomError, recoverable: boolean): RoomErrorReceivedAction {
  return {
    type: ROOM_ERROR,
    payload: {
      error: err,
      recoverable: recoverable,
    }
  };
}

function meetingDurationUpdate(elapsed: number): MeetingDurationUpdateAction {
  return {
    type: DURATION_UPDATE,
    payload: {
      elapsed: elapsed
    }
  };
}


function releaseScreen(dispatch: Dispatch<Action>, getState: () => State) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomObject;
  if (!room) {
    return dispatch(localStreamError('no room object found'));
  }
  room.stopScreen();
  dispatch(localScreenRemoved());
}


function createRoom(
  roomname: string,
  // FIXME
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rtcProvider: any,
  logger: ReturnType<typeof getLogger>,
  dispatch: ThunkDispatch<State, null, Action>,
  getState: () => State
) {
  const state = getState();
  const wsstate = (state || {}).websocket;
  const apiserver = (wsstate || {}).apiserver;
  const session = (state || {}).session;
  const stunServers = (session || {}).stunServers;
  const appconfig = (state || {}).appconfig;

  const videoRoom = new VideoRoom(
    roomname,
    rtcProvider,
    () => apiserver,
    { stunServers,
      iceReconnectRetries: appconfig.room_options.ice_reconnect_retries,
      iceReconnectRetriesWindow: appconfig.room_options.ice_reconnect_retries_window,
    },
    logger
  );

  videoRoom.onAddAudioStream = (stream) => dispatch(streamAudioAdded(stream));
  videoRoom.onRemoveAudioStream = () => dispatch(streamAudioRemoved());
  videoRoom.onNewPublisher = (p) => dispatch(addPublisher(p));
  videoRoom.onUnpublish = (id) => dispatch(removePublisher(id));

  videoRoom.onAddRemoteVideoStream = (stream, userId, type) => {
    const userIsThere = () => {
      const room = (getState() || {}).room;
      const roster = (room || {}).roster;
      return roster && roster[userId];
    };
    const doDispatch = () => {
      dispatch(streamRemoteVideoAdded(stream, userId, type));
    };
    callWhen(userIsThere, doDispatch, 10000, 5);
  };
  videoRoom.onRemoveRemoteVideoStream = (userId, type) => dispatch(streamRemoteVideoRemoved(userId, type));
  videoRoom.onToggleVideoMute = (userId, type, muted) => {
    dispatch(videoMuteToggled(userId, type, muted));
    if (!muted) {
      dispatch(subscribeToVideoSuccess(userId, type === 'remotescreenevent' ? 'screen' : 'stream'));
    }
  };
  videoRoom.onError = (err, recoverable) => {
    if (err.errorCode === 1410) {
      newEvent(WARNING, 'videoPublishFailure', err.errorMessage, err.errorMessage);
    }
    else if (err.errorCode === 1412) {
      newEvent(WARNING, 'screenPublishFailure', err.errorMessage, err.errorMessage);
    }
    else if (err.errorCode === 1413) {
      newEvent(WARNING, 'uploadICEGlitches', err.errorMessage, err.errorMessage);
    }
    else if (err.errorCode === 1414) {
      newEvent(WARNING, 'downloadICEGlitches', err.errorMessage, err.errorMessage);
    }
    else {
      dispatch(roomErrorReceived(err, recoverable));
    }
  };
  videoRoom.enableDesktopControl =
    (username, enabled, type) => dispatch(enableDesktopControl(username, enabled, type));
  videoRoom.onMeetingDuration = (elapsed) => dispatch(meetingDurationUpdate(elapsed));

  const audioRoom = new AudioRoom(() => apiserver, logger);
  audioRoom.onTalkingEvent = (username, isTalking) => dispatch(onTalkingEvent(username, isTalking));
  audioRoom.onToggleAudioMute = onToggleAudioMute(videoRoom, dispatch);

  const chatRoom = new ChatRoom(() => apiserver, logger);
  chatRoom.onEventMessageReceived = (c, s, u, d, t) => dispatch(eventMessageReceived(c, s, u, d, t));
  chatRoom.onPublicMessageReceived = (c, s, f, fd, m, t, id) =>
    dispatch(publicUserMessageReceived(c, s, f, fd, m, t, id));
  chatRoom.onPrivateMessageReceived = (c, s, to, tod, f, fd, m, t, id) =>
    dispatch(privateUserMessageReceived(c, s, to, tod, f, fd, m, t, getState(), id));

  return dispatch(roomCreated(videoRoom, audioRoom, chatRoom));
}

function onToggleAudioMute(videoRoom: VideoRoom, dispatch: ThunkDispatch<State, null, Action>) {
  return (username: string, isMuted: boolean) => {
    videoRoom.onToggleOwnAudioMute(username, isMuted);
    return dispatch(audioMuteToggled(username, isMuted));
  };
}


function setupCallStats(state: State) {
  if (!state.session.callStatsConfig) return;

  const { appId, appSecret, endpoint } = state.session.callStatsConfig;
  const backend = endpoint ? 'voismart' : 'callstatsio';
  const realm = state.session.realm;
  const displayName = state.session.displayName;
  const username = state.session.username;
  const uid = state.websocket.uid;
  const userId = {
    userName: realm ? `"${displayName}" ${username}@${realm}` : `"${displayName}" ${username}`,
    aliasName: uid,
  };
  const parsedUa = undefined; // do we need this?
  if (appId && appSecret) {
    statsStart(appId, appSecret, userId, parsedUa, { endpoint }, backend);
  }
}



function getStream(
  dispatch: Dispatch<Action>,
  getState: () => State,
  roomname: string,
  streamOptions: StreamOptions,
  logger: ReturnType<typeof getLogger>
) {
  const state = getState();
  const websocket = (getState() || {}).websocket;
  const apiserver = (websocket || {}).apiserver;
  const session = (getState() || {}).session;
  const roomState = (getState() || {}).room;
  const room = (roomState || {}).roomObject;

  if (!apiserver) {
    logger.error('no apiserver found');
    return dispatch(localStreamError('no apiserver found'));
  }
  if (!room) {
    logger.error('no room found');
    return dispatch(localStreamError('no room found'));
  }

  setupCallStats(state);

  return room.getLocalStream(getState(), streamOptions).then(
    (stream: Stream) => {
      sendConferenceMetadata(room.getConferenceID(), {
        // eslint-disable-next-line @typescript-eslint/camelcase
        room_name: roomname,
        realm: session.realm
      });
      sendUserMetadata(room.getConferenceID(), websocket.uid, {
        username: session.username,
        realm: session.realm,
        // eslint-disable-next-line @typescript-eslint/camelcase
        display_name: session.displayName
      });
      return dispatch(streamLocalVideoAdded(stream));
    }
  ).catch(
    (err: Error) => {
      reportError(room.getConferenceID(), websocket.uid, "getUserMedia");
      logger.error('error getUserMedia', err);
      return dispatch(localStreamError(err.name));
    }
  );
}


function _republishStream(
  dispatch: Dispatch<Action>,
  getState: () => State,
  streamOptions: StreamOptions,
  logger: ReturnType<typeof getLogger>
) {
  const state = (getState() || {}).websocket;
  const apiserver = (state || {}).apiserver;
  const roomState = (getState() || {}).room;
  const room = (roomState || {}).roomObject;

  if (!apiserver) {
    logger.error('no apiserver found');
    return dispatch(localStreamError('no apiserver found'));
  }
  if (!room) {
    logger.error('no room found');
    return dispatch(localStreamError('no room found'));
  }

  return room.republishStream(getState(), streamOptions).then(
    (stream: Stream) => {
      return dispatch(streamLocalVideoAdded(stream));
    }
  ).catch(
    (err: Error) => {
      reportError(room.getConferenceID(), state.uid, "getUserMedia");
      logger.error('error getUserMedia', err);
      return dispatch(localStreamError(err.name));
    }
  );
}


function _changeVideoQuality(
  dispatch: Dispatch<Action>,
  getState: () => State,
  options: VideoQualityOptions,
  logger: ReturnType<typeof getLogger>
) {
  const state = (getState() || {}).websocket;
  const apiserver = (state || {}).apiserver;
  const roomState = (getState() || {}).room;
  const room = (roomState || {}).roomObject;

  if (!apiserver) {
    logger.error('no apiserver found');
    return;
  }
  if (!room) {
    logger.error('no room found');
    return;
  }

  return room.changeVideoQuality(options);
}


function getScreenStream(
  options: ScreenSharingOptions,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomObject;
  if (!room) {
    return dispatch(localScreenError("No room object found"));
  }

  dispatch(requestScreen());

  const onstop = () => {
    dispatch(localScreenRemoved());
  };

  room.shareScreen(onstop).then(
    (stream: ScreenStream) => {
      return dispatch(localScreenAdded(stream));
    }
  ).catch(
    (err: Error) => {
      return dispatch(localScreenError(err.name));
    }
  );
}


function _tearDownRoom(dispatch: Dispatch<Action>, getState: () => State) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomObject;
  // eslint-disable-next-line @typescript-eslint/camelcase
  const audio_room = (state || {}).roomAudio;
  const chatRoom = (state || {}).chatRoom;
  if (room) {
    room.tearDown();
  }
  // eslint-disable-next-line @typescript-eslint/camelcase
  if (audio_room) {
    // eslint-disable-next-line @typescript-eslint/camelcase
    audio_room.tearDown();
  }
  if (chatRoom) {
    chatRoom.tearDown();
  }
  dispatch(streamLocalVideoRemoved());
  dispatch(streamAudioRemoved());
  dispatch(streamAllRemoteVideoRemoved());
  dispatch(localScreenRemoved());
}


function requestSubscribeToVideo(
  user: string,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomObject;
  if (!room) {
    return;
  }
  const uid = user.replace(/_screen$/, '');
  const userData = state.roster[uid];
  const key = user.endsWith('_screen') ? 'screenPublisherData' : 'streamPublisherData';
  const type = user.endsWith('_screen') ? 'screen' : 'stream';
  if (userData) {
    const publisher = userData[key];
    if (publisher && !publisher.subscribed && !publisher.subscribeRequested) {
      dispatch(subscribeToVideoRequested(uid, type));
      room.subscribeToVideo(publisher).catch(() => dispatch(subscribeToVideoError(uid, type)));
    }
  }
}


function requestSubscribeToAllVideos(
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomObject;
  if (!room) {
    return;
  }
  const roster = state.roster;
  Object.keys(roster).forEach(uid => {
    requestSubscribeToVideo(uid, dispatch, getState);
    requestSubscribeToVideo(`${uid}_screen`, dispatch, getState);
  });
}


function _shouldToggleVideoMute(user: string, state: State, mute: boolean) {
  const rosterUser = state.roster[user.replace(/_screen$/, '')] as RosterUser;
  if (user.includes('_screen')) {
    return rosterUser.isScreenMuted !== mute
      && !rosterUser.isRequestingVideoMute
      && rosterUser.screenPublisherData
      && rosterUser.screenPublisherData.subscribed;
  } else {
    return rosterUser.isVideoMuted !== mute
      && !rosterUser.isRequestingVideoMute
      && rosterUser.streamPublisherData
      && rosterUser.streamPublisherData.subscribed;
  }
}

function requestToggleVideoMute(
  user: string,
  muted: boolean,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomObject;
  if (!room || !_shouldToggleVideoMute(user, state, muted)) {
    return;
  }
  const userToDispatchTo = user.replace(/_screen$/, '');
  dispatch(videoMuteToggleRequested(userToDispatchTo));
  room.toggleVideoMute(user, muted).catch(() => dispatch(videoMuteToggleError(user)));
}


function requestToggleAudioMute(
  user: string,
  muted: boolean,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = (getState() || {}).room;
  const room = (state || {}).roomAudio;
  if (!room) {
    return;
  }
  dispatch(audioMuteToggleRequested(user));
  room.toggleAudioMute(user, muted).catch(() => dispatch(audioMuteToggleError(user)));
}


function requestMuteAll(dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomAudio;
  const wsState = (state || {}).websocket;
  const user = (wsState || {}).uid;
  if (!(room && user)) {
    return;
  }
  dispatch(audioMuteAllRequested(user));
  room.muteAll().finally(() => dispatch(audioMuteAllDone(user)));
}


function requestUnMuteAll(dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomAudio;
  const wsState = (state || {}).websocket;
  const user = (wsState || {}).uid;
  if (!(room && user)) {
    return;
  }
  dispatch(audioMuteAllRequested(user));
  room.unMuteAll().finally(() => dispatch(audioMuteAllDone(user)));
}


function requestToggleOwnAudioMute(muted: boolean, dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomAudio;
  const wsState = (state || {}).websocket;
  const user = (wsState || {}).uid;
  if (!(room && user)) {
    return;
  }
  dispatch(audioMuteToggleRequested(user));
  room.toggleOwnAudioMute(muted).catch(() => dispatch(audioMuteToggleError(user)));
}


function requestPublishVideo(published: boolean, dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  const wsState = (state || {}).websocket;
  const user = (wsState || {}).uid;
  if (!(room && user)) {
    return;
  }
  dispatch(videoMuteToggleRequested(user));
  room.togglePublishVideo(published);
}


function requestUserKick(user: string, dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && user)) {
    return;
  }
  dispatch(kickUserRequested(user));
  room.kickUser(user)
    .then(() => dispatch(kickUserSuccess(user)))
    .catch(() => dispatch(kickUserError(user)));
}


function requestExpandStreamVideo(
  user: string,
  streamType: RoomLayoutStreamType,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && user)) {
    return;
  }
  dispatch(expandStreamVideoRequested(user, streamType));
}


function requestEnlargeStreamVideo(
  enlarge: boolean,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  dispatch(enlargeStreamVideoRequested(enlarge));
}


function requestInviteParticipants(
  emails: string[],
  params: Params,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && emails)) {
    return;
  }
  dispatch(inviteParticipantsRequested());
  room.inviteParticipants(emails, params)
    .then(() => dispatch(inviteParticipantsSuccess()))
    .catch((err: RoomError) => {
      newEvent(ERROR, err.code, err.reason, err.message);
      dispatch(inviteParticipantsError(err.code));
    });
}


function requestToggleInviteParticipantsDialog(dispatch: Dispatch<Action>) {
  dispatch(inviteParticipantsToggleDialog());
}


function requestDialParticipant(
  destination: string,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && destination)) {
    return;
  }
  dispatch(dialParticipantRequested());
  room.dialParticipant(destination)
    .then(() => {
      newEvent(INFO, 'dialParticipantSuccess', 'dialParticipantSuccess',
        'Call started successfully.');
      dispatch(dialParticipantSuccess());
    })
    .catch((err: RoomError) => {
      newEvent(ERROR, err.code, err.reason, err.message);
      dispatch(dialParticipantError(err.code));
    });
}


function requestUserRoleChange(
  user: string,
  role: string,
  dispatch: Dispatch<Action>,
  getState: () => State
) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && user)) {
    return;
  }
  dispatch(changeUserRoleRequested(user));
  room.changeUserRole(user, role)
    .then(() => dispatch(changeUserRoleSuccess(user)))
    .catch(() => dispatch(changeUserRoleError(user)));
}


function requestApplyLayout(dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  const layout = state.room.layout;
  const layoutConfig = state.room.layoutConfig;
  dispatch(applyLayoutRequested());
  room.applyLayout(layout, layoutConfig)
    .then(() => dispatch(applyLayoutSuccess()))
    .catch(() => dispatch(applyLayoutError()));
}


function requestLockRoom(dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  dispatch(lockRoomRequested());
  room.toggleRoomLock()
    .then((res: { locked: boolean }) => dispatch(lockRoomStatus(res.locked)))
    .catch(() => dispatch(lockRoomError()));
}


function requestStartRecording(params: Params, dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  dispatch(startRecordingRequested());
  room.startRecording(params)
    .catch((err: RoomError) => {
      newEvent(ERROR, err.code, err.reason, err.message);
      dispatch(startRecordingError());
    });
}


function requestStopRecording(dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  dispatch(stopRecordingRequested());
  room.stopRecording()
    .then(() => dispatch(stopRecordingSuccess()))
    .catch((err: RoomError) => {
      newEvent(ERROR, err.code, err.reason, err.message);
      dispatch(stopRecordingError());
    });
}


function requestStartLivestreaming(params: Params, dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  dispatch(startLivestreamingRequested());
  room.startLivestreaming(params)
    .catch((err: RoomError) => {
      newEvent(ERROR, err.code, err.reason, err.message);
      dispatch(startLivestreamingError());
    });
}


function requestStopLivestreaming(dispatch: Dispatch<Action>, getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room)) {
    return;
  }
  dispatch(stopLivestreamingRequested());
  room.stopLivestreaming()
    .then(() => dispatch(stopLivestreamingSuccess()))
    .catch((err: RoomError) => {
      newEvent(ERROR, err.code, err.reason, err.message);
      dispatch(stopLivestreamingError());
    });
}


export function createVideoRoom(
  room: string,
  // FIXME
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rtcProvider: any,
  logger: ReturnType<typeof getLogger>
): RoomThunkAction {
  return (dispatch, getState) => {
    return createRoom(room, rtcProvider, logger, dispatch, getState);
  };
}


export function addStream(
  room: string,
  streamOptions: StreamOptions,
  logger: ReturnType<typeof getLogger>
): RoomThunkAction {
  return (dispatch, getState) => {
    return getStream(dispatch, getState, room, streamOptions, logger);
  };
}


export function tearDownRoom(): RoomThunkAction {
  return (dispatch, getState) => {
    return _tearDownRoom(dispatch, getState);
  };
}


export function republishStream(
  streamOptions: StreamOptions,
  logger: ReturnType<typeof getLogger>
): RoomThunkAction {
  return (dispatch, getState) => {
    return _republishStream(dispatch, getState, streamOptions, logger);
  };
}


export function changeVideoQuality(
  options: VideoQualityOptions,
  logger: ReturnType<typeof getLogger>
): RoomThunkAction {
  return (dispatch, getState) => {
    return _changeVideoQuality(dispatch, getState, options, logger);
  };
}


export function shareScreen(options: ScreenSharingOptions = {}): RoomThunkAction {
  return (dispatch, getState) => {
    return getScreenStream(options, dispatch, getState);
  };
}


export function stopScreenSharing(): RoomThunkAction {
  return (dispatch, getState) => {
    return releaseScreen(dispatch, getState);
  };
}


export function subscribeToVideo(user: string): RoomThunkAction {
  return (dispatch, getState) => {
    return requestSubscribeToVideo(user, dispatch, getState);
  };
}


export function subscribeToAllVideos(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestSubscribeToAllVideos(dispatch, getState);
  };
}


export function toggleVideoMute(user: string, muted: boolean): RoomThunkAction {
  return (dispatch, getState) => {
    return requestToggleVideoMute(user, muted, dispatch, getState);
  };
}

export function toggleAllVideoMute(muted: boolean, filter?: (s: string) => boolean): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).roomObject;
    if (!room) {
      return;
    }
    const roster = roomState.roster;

    const websocketState = (state || {}).websocket;
    const myUid = websocketState.uid;

    Object.keys(roster).forEach(
      (uid) => {
        if (uid !== myUid) {
          if (filter) {
            if (filter(uid)) {
              requestToggleVideoMute(uid, muted, dispatch, getState);
              requestToggleVideoMute(`${uid}_screen`, muted, dispatch, getState);
            }
          }
          else {
            requestToggleVideoMute(uid, muted, dispatch, getState);
            requestToggleVideoMute(`${uid}_screen`, muted, dispatch, getState);
          }
        }
      }
    );
  };
}

function requestEnableDesktopControl(
  user: string,
  desktopControlEnabled: boolean,
  desktopControlType: string,
  dispatch: Dispatch<Action>,
  getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && user)) {
    return;
  }
  dispatch(requestDesktopControl(user));
  desktopControlEnabled ? room.startDeskControl(user, desktopControlType) : room.stopDeskControl(user);
}

export function enableDesktopControl(
  user: string,
  desktopControlEnabled: boolean,
  desktopControlType: string
): RoomThunkAction {
  return (dispatch, getState) => {
    return requestEnableDesktopControl(user, desktopControlEnabled, desktopControlType, dispatch, getState);
  };
}

export function toggleAudioMute(user: string, muted: boolean): RoomThunkAction {
  return (dispatch, getState) => {
    return requestToggleAudioMute(user, muted, dispatch, getState);
  };
}


export function toggleOwnAudioMute(muted: boolean): RoomThunkAction {
  return (dispatch, getState) => {
    return requestToggleOwnAudioMute(muted, dispatch, getState);
  };
}


export function muteAll(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestMuteAll(dispatch, getState);
  };
}


export function unMuteAll(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestUnMuteAll(dispatch, getState);
  };
}


export function togglePublishVideo(published: boolean): RoomThunkAction {
  return (dispatch, getState) => {
    return requestPublishVideo(published, dispatch, getState);
  };
}


export function kickUser(user: string): RoomThunkAction {
  return (dispatch, getState) => {
    return requestUserKick(user, dispatch, getState);
  };
}

function requestSendMouseEvent(
  userId: string,
  displayName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseEventType: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseEventData: any,
  dispatch: Dispatch,
  getState: () => State) {
  const state = getState();
  const roomState = (state || {}).room;
  const room = (roomState || {}).roomObject;
  if (!(room && userId)) {
    return;
  }

  room.mouseEvent(userId, displayName, mouseEventType, mouseEventData)
    .catch((err: Error) => {
      const logger = getLogger('MouseEvent');
      logger.error("error is", err);
    });
}

export function sendMouseEvent(
  userId: string,
  displayName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseEventType: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseEventData: any
): RoomThunkAction {
  return (dispatch, getState) => {
    return requestSendMouseEvent(userId, displayName, mouseEventType, mouseEventData, dispatch, getState);
  };
}


export function startControllingDesktop(): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).roomObject;
    if (!room) {
      return;
    }

    room.startControllingDesktop()
      .catch((err: Error) => {
        const logger = getLogger('Desktop Control');
        logger.error("error is", err);
      });
  };
}


export function stopControllingDesktop(): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).roomObject;
    if (!room) {
      return;
    }

    room.stopControllingDesktop()
      .catch((err: Error) => {
        const logger = getLogger('Desktop Control');
        logger.error("error is", err);
      });
  };
}


export function startDrawing(): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).roomObject;

    if (!room) {
      return;
    }

    room.startDrawing()
      .catch((err: Error) => {
        const logger = getLogger('Drawing');
        logger.error("error is", err);
      });
  };
}


export function stopDrawing(): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).roomObject;
    if (!room) {
      return;
    }

    room.stopDrawing()
      .catch((err: Error) => {
        const logger = getLogger('Drawing');
        logger.error("error is", err);
      });
  };
}


export function enlargeStreamVideo(enlarge: boolean): RoomThunkAction {
  return (dispatch, getState) => {
    return requestEnlargeStreamVideo(enlarge, dispatch, getState);
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
export function expandStreamVideo(user: string, stream_type: RoomLayoutStreamType): RoomThunkAction {
  return (dispatch, getState) => {
    return requestExpandStreamVideo(user, stream_type, dispatch, getState);
  };
}


export function addObservedScreen(uid: string): AddObservedScreenAction {
  return {
    type: ADD_OBSERVED_SCREEN,
    payload: {
      userId: uid,
    }
  };
}


export function removeObservedScreen(uid: string): RemoveObservedScreenAction {
  return {
    type: REMOVE_OBSERVED_SCREEN,
    payload: {
      userId: uid,
    }
  };
}


export function inviteParticipants(emails: string[], params: Params): RoomThunkAction {
  return (dispatch, getState) => {
    return requestInviteParticipants(emails, params, dispatch, getState);
  };
}


export function toggleInviteParticipantsDialog(): RoomThunkAction {
  return (dispatch) => {
    return requestToggleInviteParticipantsDialog(dispatch);
  };
}


export function togglePip(pipUser: string | null): TogglePipUserAction {
  return {
    type: PIP_USER,
    payload: {
      pipUser: pipUser,
    }
  };
}



export function toggleFullscreen(fullscreenUser: string | null): ToggleFullscreenUserAction {
  return {
    type: FULLSCREEN_USER,
    payload: {
      fullscreenUser: fullscreenUser,
    }
  };
}


export function dialParticipant(destination: string): RoomThunkAction {
  return (dispatch, getState) => {
    return requestDialParticipant(destination, dispatch, getState);
  };
}

export function changeRole(user: string, role: string): RoomThunkAction {
  return (dispatch, getState) => {
    return requestUserRoleChange(user, role, dispatch, getState);
  };
}


export function applyLayout(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestApplyLayout(dispatch, getState);
  };
}


export function lockRoom(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestLockRoom(dispatch, getState);
  };
}


export function startRecording(params: Params): RoomThunkAction {
  return (dispatch, getState) => {
    return requestStartRecording(params, dispatch, getState);
  };
}


export function stopRecording(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestStopRecording(dispatch, getState);
  };
}


export function startLivestreaming(params: Params): RoomThunkAction {
  return (dispatch, getState) => {
    return requestStartLivestreaming(params, dispatch, getState);
  };
}


export function stopLivestreaming(): RoomThunkAction {
  return (dispatch, getState) => {
    return requestStopLivestreaming(dispatch, getState);
  };
}


export function sendChatMessage(message: string, to?: string): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).chatRoom;
    if (!room) {
      return;
    }
    room.publishChatMessage(message, to)
      .catch((err: ChatMessageError) => {
        if (err.error === ChatMessageErrorType.UserOffline) {
          newEvent(WARNING, 'userOffline', err.error, err.error);
        } else {
          newEvent(WARNING, 'userInvalid', err.error, err.error);
        }
      });
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
export function changeLayout(layout_type: RoomLayout, layout_config: RoomLayoutConfig): ChangeLayoutAction {
  return {
    type: CHANGE_LAYOUT,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      layout_type: layout_type,
      // eslint-disable-next-line @typescript-eslint/camelcase
      layout_config: layout_config
    }
  };
}


// eslint-disable-next-line @typescript-eslint/camelcase
export function forceLayout(layout_type: RoomLayout, layout_config: RoomLayoutConfig): ForceLayoutAction {
  return {
    type: FORCE_LAYOUT,
    payload: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      layout_type: layout_type,
      // eslint-disable-next-line @typescript-eslint/camelcase
      layout_config: layout_config
    }
  };
}
// export function setMousePointer(mousePointer) {
//   return {
//     type: SET_MOUSE_POINTER,
//     payload: {
//       mousePointer
//     }
//   };
// }
// export function clearMousePointers() {
//   return {
//     type: CLEAR_MOUSE_POINTERS,
//     payload: {
//     }
//   };
// }


export function setChatOpen(isOpen: boolean): SetChatOpenAction {
  return {
    type: SET_CHAT_OPEN,
    payload: {
      isOpen: isOpen
    }
  };
}


export function resetUnreadPublicUserMessages(): PublicUserMessagesResetAction {
  return {
    type: PUBLIC_USERMESSAGE_RESET_UNREAD,
    payload: {}
  };
}


export function resetUnreadPrivateUserMessages(): PrivateUserMessagesResetAction {
  return {
    type: PRIVATE_USERMESSAGE_RESET_UNREAD,
    payload: {}
  };
}


export function resetUnreadPrivateUserMessageThread(user: string): PrivateUserMessagesResetThreadAction {
  return {
    type: PRIVATE_USERMESSAGE_RESET_UNREAD_THREAD,
    payload: {
      thread: user,
    }
  };
}


export function roomErrorAcked(): RoomErrorAckedAction {
  return {
    type: ROOM_ERROR_ACKED,
    payload: {
    }
  };
}


export function endMeeting(): RoomThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const roomState = (state || {}).room;
    const room = (roomState || {}).roomObject;
    if (!room) {
      return;
    }
    room.endMeeting();
  };
}
